// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { useUniqueId } from '@cloudscape-design/component-toolkit/internal';
import { useFormFieldContext } from '../contexts/form-field';
import DropdownFooter from '../internal/components/dropdown-footer';
import PlainList from '../internal/components/listbox/parts/plain-list';
import ScreenreaderOnly from '../internal/components/screenreader-only';
import VirtualList from '../select/parts/virtual-list';
import { useMultiselect } from './use-multiselect';
import styles from './styles.css.js';
const EmbeddedMultiselect = React.forwardRef(({ options, filteringType, ariaLabel, selectedOptions, deselectAriaLabel, virtualScroll, filteringText = '', ...restProps }, externalRef) => {
    const formFieldContext = useFormFieldContext(restProps);
    const ariaLabelId = useUniqueId('multiselect-ariaLabel-');
    const footerId = useUniqueId('multiselect-footer-');
    const multiselectProps = useMultiselect({
        options,
        selectedOptions,
        filteringType,
        disabled: false,
        deselectAriaLabel,
        controlId: formFieldContext.controlId,
        ariaLabelId,
        footerId,
        filteringValue: filteringText,
        externalRef,
        keepOpen: true,
        embedded: true,
        ...restProps,
    });
    const ListComponent = virtualScroll ? VirtualList : PlainList;
    const status = multiselectProps.dropdownStatus;
    return (React.createElement("div", { className: styles.embedded },
        React.createElement(ListComponent, { listProps: multiselectProps.getMenuProps(), getOptionProps: multiselectProps.getOptionProps, filteredOptions: multiselectProps.filteredOptions, filteringValue: filteringText, ref: multiselectProps.scrollToIndex, hasDropdownStatus: status.content !== null, selectionType: "multi", screenReaderContent: multiselectProps.announcement, highlightType: multiselectProps.highlightType, isMultiSelect: true }),
        status.content && React.createElement(DropdownFooter, { content: status.content, id: footerId }),
        React.createElement(ScreenreaderOnly, { id: ariaLabelId }, ariaLabel)));
});
export default EmbeddedMultiselect;
//# sourceMappingURL=embedded.js.map